'use client';
import React, { useState } from 'react';
import { AlertTriangle, AlertCircle, X, ChevronRight } from 'lucide-react';

const ALERTS = [
  {
    id: 'rti-fps',
    icon: AlertTriangle,
    bg: 'bg-warning/8 border-warning/25',
    iconBg: 'bg-warning/15',
    iconColor: 'text-warning',
    actionColor: 'text-warning hover:text-warning/80',
    title: 'RTI Full Payment Submission due today',
    detail: 'Week 18 FPS must be submitted to HMRC by 23:59 tonight (04 May 2026). 3 timesheets still pending approval.',
    action: 'Review',
  },
  {
    id: 'dbs-expiry',
    icon: AlertCircle,
    bg: 'bg-danger/8 border-danger/25',
    iconBg: 'bg-danger/15',
    iconColor: 'text-danger',
    actionColor: 'text-danger hover:text-danger/80',
    title: '2 DBS checks expiring within 30 days',
    detail: 'Priya Nair (expires 15 May 2026) · Cian Walsh (expires 28 May 2026). Renew via DBS Update Service.',
    action: 'Renew',
  },
];

export default function ComplianceAlertBanner() {
  const [dismissed, setDismissed] = useState<Set<string>>(new Set());
  const visible = ALERTS.filter((a) => !dismissed.has(a.id));
  if (visible.length === 0) return null;

  return (
    <div className="space-y-2 animate-fade-in">
      {visible.map((alert) => (
        <div key={alert.id} className={`flex items-center gap-3 border rounded-xl px-4 py-3 ${alert.bg}`}>
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${alert.iconBg}`}>
            <alert.icon size={16} className={alert.iconColor} />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[13px] font-600 text-foreground">{alert.title}</p>
            <p className="text-[12px] text-muted-foreground mt-0.5">{alert.detail}</p>
          </div>
          <button className={`flex items-center gap-1 text-[12px] font-500 transition-colors shrink-0 ${alert.actionColor}`}>
            {alert.action} <ChevronRight size={12} />
          </button>
          <button
            onClick={() => setDismissed((prev) => new Set([...prev, alert.id]))}
            className="text-muted-foreground hover:text-foreground transition-colors shrink-0 ml-1"
            aria-label="Dismiss alert"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}